const candidateRecoveryReducer = (state = {}, action) => {
    switch (action?.type) {
        case 'VERIFICATION_DETAILS':
            return {
                ...state,
                verificationDetails: action?.payload,
            };
        default:
            return state;
    }
};

export default candidateRecoveryReducer;
